/* ML Immo-Konzept – Seite "Beispiele".
   Eigenstaendiges Vanilla-JS, keine Theme-Imports, alle Hooks mit bsp-Praefix.
   Ohne dieses Skript bleibt die Seite vollstaendig lesbar (erster Zustand serverseitig aktiv). */

(function () {
  var SWIPE_MIN = 40;

  /* ---------------- Beispiel 01: Zustands-Umschalter ---------------- */

  function initWandel(root) {
    if (!root || root.getAttribute('data-bsp-ready') === '1') return;
    root.setAttribute('data-bsp-ready', '1');

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-bsp-index]'));
    var frames = Array.prototype.slice.call(root.querySelectorAll('.bsp-frame'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('.bsp-panel'));
    var markers = Array.prototype.slice.call(root.querySelectorAll('[data-bsp-marker]'));
    var segs = Array.prototype.slice.call(root.querySelectorAll('[data-bsp-seg]'));
    var stage = root.querySelector('.bsp-stage');
    if (!tabs.length) return;

    var current = 0;

    function closeMarkers(except) {
      for (var m = 0; m < markers.length; m++) {
        if (markers[m] !== except) markers[m].setAttribute('aria-expanded', 'false');
      }
    }

    function updateSegs(count) {
      for (var s = 0; s < segs.length; s++) {
        var idx = parseInt(segs[s].getAttribute('data-bsp-seg'), 10);
        segs[s].classList.toggle('is-on', idx < count);
      }
    }

    function activate(index, focusTab) {
      if (index < 0) index = 0;
      if (index > tabs.length - 1) index = tabs.length - 1;
      current = index;

      for (var i = 0; i < tabs.length; i++) {
        var on = i === index;
        tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
        tabs[i].setAttribute('tabindex', on ? '0' : '-1');
        if (frames[i]) {
          frames[i].classList.toggle('is-active', on);
          if (on) frames[i].removeAttribute('aria-hidden');
          else frames[i].setAttribute('aria-hidden', 'true');
        }
        if (panels[i]) panels[i].classList.toggle('is-active', on);
      }

      closeMarkers(null);
      var lvl = parseInt(tabs[index].getAttribute('data-bsp-leistung'), 10);
      updateSegs(isNaN(lvl) ? 0 : lvl);

      if (focusTab && tabs[index]) tabs[index].focus();
    }

    // Marker: Klick/Enter zeigt genau ein Label, Overflow-Schutz gegen Bildrand
    function positionLabel(marker) {
      var label = marker.querySelector('.bsp-marker-label');
      if (!label || !stage) return;
      marker.classList.remove('bsp-marker--down');
      label.style.setProperty('--bsp-shift', '0px');

      var sr = stage.getBoundingClientRect();
      var lr = label.getBoundingClientRect();
      if (lr.top < sr.top + 4) marker.classList.add('bsp-marker--down');

      lr = label.getBoundingClientRect();
      var shift = 0;
      if (lr.right > sr.right - 6) shift = -(lr.right - (sr.right - 6));
      else if (lr.left < sr.left + 6) shift = sr.left + 6 - lr.left;
      if (shift) label.style.setProperty('--bsp-shift', Math.round(shift) + 'px');
    }

    markers.forEach(function (marker) {
      marker.addEventListener('click', function () {
        var open = marker.getAttribute('aria-expanded') === 'true';
        closeMarkers(marker);
        if (open) {
          marker.setAttribute('aria-expanded', 'false');
          return;
        }
        marker.setAttribute('aria-expanded', 'true');
        positionLabel(marker);
      });
    });

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        activate(i, false);
      });
    });

    // Tastatur: Pfeiltasten, Pos1/Ende
    var tablist = root.querySelector('[role="tablist"]');
    if (tablist) {
      tablist.addEventListener('keydown', function (e) {
        var key = e.key;
        if (key === 'ArrowRight' || key === 'ArrowDown') {
          e.preventDefault();
          activate(current + 1 > tabs.length - 1 ? 0 : current + 1, true);
        } else if (key === 'ArrowLeft' || key === 'ArrowUp') {
          e.preventDefault();
          activate(current - 1 < 0 ? tabs.length - 1 : current - 1, true);
        } else if (key === 'Home') {
          e.preventDefault();
          activate(0, true);
        } else if (key === 'End') {
          e.preventDefault();
          activate(tabs.length - 1, true);
        }
      });
    }

    // Wischgeste auf der Bildbuehne – vertikales Scrollen bleibt moeglich
    if (stage) attachTouch(stage);

    function attachTouch(el) {
      var startX = 0;
      var startY = 0;
      var tracking = false;

      el.addEventListener(
        'touchstart',
        function (e) {
          if (!e.touches || e.touches.length !== 1) {
            tracking = false;
            return;
          }
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
          tracking = true;
        },
        { passive: true }
      );

      el.addEventListener(
        'touchend',
        function (e) {
          if (!tracking) return;
          tracking = false;
          var touch = (e.changedTouches && e.changedTouches[0]) || null;
          if (!touch) return;
          var dx = touch.clientX - startX;
          var dy = touch.clientY - startY;
          // Nur horizontal auswerten: Richtung muss eindeutig sein
          if (Math.abs(dx) < SWIPE_MIN) return;
          if (Math.abs(dx) <= Math.abs(dy)) return;
          if (dx < 0) {
            activate(current + 1 > tabs.length - 1 ? tabs.length - 1 : current + 1, false);
          } else {
            activate(current - 1 < 0 ? 0 : current - 1, false);
          }
        },
        { passive: true }
      );
    }

    // Startzustand sauber setzen (serverseitig ist Index 0 aktiv)
    activate(0, false);
  }

  /* ---------------- Beispiel 02: Lightbox ---------------- */

  var lightbox = null;
  var lightboxImg = null;
  var lightboxCap = null;
  var lightboxClose = null;
  var lastTrigger = null;

  function buildLightbox() {
    if (lightbox) return lightbox;

    lightbox = document.createElement('div');
    lightbox.className = 'bsp-lightbox';
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.setAttribute('aria-label', 'Bild vergrößert');
    lightbox.hidden = true;

    lightboxClose = document.createElement('button');
    lightboxClose.type = 'button';
    lightboxClose.className = 'bsp-lightbox-close';
    lightboxClose.setAttribute('aria-label', 'Schließen');
    lightboxClose.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>';

    lightboxImg = document.createElement('img');
    lightboxImg.className = 'bsp-lightbox-img';
    lightboxImg.alt = '';

    lightboxCap = document.createElement('p');
    lightboxCap.className = 'bsp-lightbox-cap';

    lightbox.appendChild(lightboxClose);
    lightbox.appendChild(lightboxImg);
    lightbox.appendChild(lightboxCap);
    document.body.appendChild(lightbox);

    lightboxClose.addEventListener('click', closeLightbox);

    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) closeLightbox();
    });

    document.addEventListener('keydown', function (e) {
      if (lightbox.hidden) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        closeLightbox();
      } else if (e.key === 'Tab') {
        // Fokusfalle: nur der Schliessen-Button ist fokussierbar
        e.preventDefault();
        lightboxClose.focus();
      }
    });

    return lightbox;
  }

  function openLightbox(src, alt, caption, trigger) {
    buildLightbox();
    lastTrigger = trigger || null;
    lightboxImg.src = src;
    lightboxImg.alt = alt || '';
    lightboxCap.textContent = caption || '';
    lightbox.hidden = false;
    document.body.classList.add('bsp-noscroll');
    lightboxClose.focus();
  }

  function closeLightbox() {
    if (!lightbox || lightbox.hidden) return;
    lightbox.hidden = true;
    lightboxImg.removeAttribute('src');
    document.body.classList.remove('bsp-noscroll');
    if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
    lastTrigger = null;
  }

  function initZoom(scope) {
    var triggers = (scope || document).querySelectorAll('[data-bsp-zoom]');
    Array.prototype.forEach.call(triggers, function (btn) {
      if (btn.getAttribute('data-bsp-ready') === '1') return;
      btn.setAttribute('data-bsp-ready', '1');
      btn.addEventListener('click', function () {
        openLightbox(
          btn.getAttribute('data-bsp-src'),
          btn.getAttribute('data-bsp-alt'),
          btn.getAttribute('data-bsp-cap'),
          btn
        );
      });
    });
  }

  /* ---------------- Start ---------------- */

  function boot(scope) {
    var roots = (scope || document).querySelectorAll('[data-bsp-wandel]');
    Array.prototype.forEach.call(roots, initWandel);
    initZoom(scope);
  }

  if (document.readyState !== 'loading') {
    boot(document);
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  }

  // Theme-Editor: Sektion wird neu geladen
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) {
      var w = e.target.querySelector ? e.target.querySelector('[data-bsp-wandel]') : null;
      if (w) w.removeAttribute('data-bsp-ready');
      boot(e.target);
    }
  });
})();
